import { DateTime } from 'luxon'

/**
 * Keeps [now] current, e.g. to show a running time as now minus its start.
 *
 * Computing running times from now instead of adding up timer ticks keeps them right after the device slept, since
 * timers do not run meanwhile. It updates every [interval] and as soon as the page becomes visible again.
 */
const useNow = (interval = 15000) => ({
  data () {
    return {
      now: DateTime.now()
    }
  },
  created () {
    this.updateNow = () => {
      this.now = DateTime.now()
    }
    this.nowIntervalId = setInterval(this.updateNow, interval)
    document.addEventListener('visibilitychange', this.updateNow)
  },
  beforeDestroy () {
    clearInterval(this.nowIntervalId)
    document.removeEventListener('visibilitychange', this.updateNow)
  }
})

export default useNow
